var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: this.styleOptions }, [
    _c(
      "div",
      {
        staticClass: "metric-card",
        style: { height: this.height + "" + "px" },
      },
      [
        _c("p", { staticClass: "name" }, [
          _vm._v(
            _vm._s(
              _vm._f("truncate")(
                _vm._f("sentenceCase")(_vm.metric.name ? _vm.metric.name : ""),
                50
              )
            )
          ),
        ]),
        _vm._v(" "),
        _c(
          "p",
          { staticClass: "metric", class: _vm.isText ? "metric__text" : "" },
          [_vm._v(_vm._s(_vm.metricValue))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }